// Court Jurisdiction reference data for the Case Info tab
//
// "Court Jurisdiction" in the EFM is a courthouse location picker. Categories
// that show it (21, 12, 14, 4, 13) let the user choose which courthouse to
// file at. The EFM populates this dynamically via GetEFileLocationsECF based
// on category and zip code.
//
// This static data is extracted from LegalConnect for LA County (2026-02-21).
// Each category has its own set of courthouses — only Family (12) is populated
// here. Other categories will be populated in a follow-up extraction or
// replaced with an API-driven approach.
//
// The `code` is the EFM location code needed for filing submission.
// Our court DB (zones-courts.json) has 11 of 12 matching records with
// courtType "Family" or "State" + "Family eFiling" in jurisdiction name.
/**
 * Court Jurisdiction options by category EFM code.
 * Populated from LegalConnect extraction. Each category shows different
 * courthouse locations — only Family is complete here.
 */
const COURT_JURISDICTIONS = {
    // LA County — Family — 12 courthouses (verified 2026-02-21)
    '12': [
        { code: 'LOSANGELES:MAAVC', name: 'Los Angeles County - AV - Family' },
        { code: 'LOSANGELES:CHATC', name: 'Los Angeles County - Chatsworth Courthouse - Family' },
        { code: 'LOSANGELES:CC', name: 'Los Angeles County - Compton Courthouse - Family' },
        { code: 'LOSANGELES:GGDC', name: 'Los Angeles County - Governor George Deukmejian Courthouse - Family' },
        { code: 'LOSANGELES:FAMING', name: 'Los Angeles County - Inglewood - Family' },
        { code: 'LOSANGELES:PC', name: 'Los Angeles County - Pasadena Courthouse - Family' },
        { code: 'LOSANGELES:PCS', name: 'Los Angeles County - Pomona Courthouse South - Family' },
        { code: 'LOSANGELES:SMC', name: 'Los Angeles County - Santa Monica Courthouse - Family' },
        { code: 'LOSANGELES:STANMC', name: 'Los Angeles County - SMC - Family' },
        { code: 'LOSANGELES:TC', name: 'Los Angeles County - Torrance Courthouse - Family' },
        { code: 'LOSANGELES:VNCE', name: 'Los Angeles County - Van Nuys Courthouse East - Family' },
        { code: 'LOSANGELES:WC', name: 'Los Angeles County - Whittier Courthouse - Family' },
    ],
    // Madera — single courthouse for all categories
    '211110': [
        { code: 'MADERA', name: 'Madera Superior Court' },
    ],
    '411110': [
        { code: 'MADERA', name: 'Madera Superior Court' },
    ],
    '421110': [
        { code: 'MADERA', name: 'Madera Superior Court' },
    ],
    '511110': [
        { code: 'MADERA', name: 'Madera Superior Court' },
    ],
    '711110': [
        { code: 'MADERA', name: 'Madera Superior Court' },
    ],
};
/**
 * Get Court Jurisdiction dropdown options for a category.
 * Returns an empty array for categories without static data.
 */
export function getCourtJurisdictions(categoryEfmCode) {
    if (!categoryEfmCode)
        return [];
    return COURT_JURISDICTIONS[categoryEfmCode] ?? [];
}
